import type { UseCase } from "./useCases";
import { LocationPros } from "../types/baseTypes";

export const hexToRgba = (hex: string, opacity: number) => {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');
  
    // Parse the hex color
    let r = parseInt(hex.substr(0, 2), 16);
    let g = parseInt(hex.substr(2, 2), 16);
    let b = parseInt(hex.substr(4, 2), 16);
  
    // Return the rgba color
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export const isEmptyObject = (obj: any) => {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const getSvcLocations = (
    locations: LocationPros[], 
    service: UseCase
) => {
    return locations?.filter(
        (loc: LocationPros) => loc.services.includes(service)
    ); 
};

export const getKeyWithTermsOfServiceInLowercase = (
  obj: Record<string, any>
): string | undefined  => {  
  for (const key in obj) {
    if (key.toLowerCase().includes("termsofservice")) {
      return key;
    }
  }
  return undefined;
}